<template>
    <div id="menu_container">
        
      <img id="logo" class="mb-4" draggable="false" src='@/assets/logo.png'>
        
        <span id="alarm" class="bi-bell-fill"></span>
        
        <p :class="getNameClassStyle()">
          <span v-if="$store.state.type != 'user'">&nbsp;</span>{{ $store.state.name }}
        </p>
        <p class="session_time">Session Ends in: {{ session_life }}</p>

        <div id="menu" class="">
            <RouterLink class="btn btn-roadfly bi-person-circle mb-2" to='/profile'><span>Profile</span></RouterLink>
            <RouterLink v-if="$store.getters.access('misc_dashboard')" class="btn btn-roadfly bi-ui-checks-grid mb-2" to='/dash'><span>Dashboard</span></RouterLink> 
            <RouterLink v-if="$store.getters.access('misc_statistics')" class="btn btn-roadfly bi-graph-up-arrow mb-2" to='/statistics'><span>Felousy Feen</span></RouterLink> 
            <RouterLink v-if="$store.getters.access('misc_tweaks')" class="btn btn-roadfly bi-wrench mb-2" to='/settings'><span>Settings</span></RouterLink> 
            
            <div class="btn-group dropend mb-2" v-if="$store.getters.access('user')" >
              <a class="btn btn-roadfly bi-person-fill-gear dropdown-toggle" data-bs-toggle='dropdown'><span>Users</span></a>
              <ul class='dropdown-menu'>
                <li><RouterLink class="dropdown-item" to='/users'>Manage Users</RouterLink></li>
                <li><RouterLink class="dropdown-item" to='/logs'>View All Logs</RouterLink></li>
              </ul>
            </div>

            <RouterLink v-if="$store.getters.access('branch')" class="btn btn-roadfly bi-buildings-fill mb-2" to='/branches'><span>Branches</span></RouterLink> 
            <RouterLink v-if="$store.getters.access('expense')" class="btn btn-roadfly bi-coin mb-2" to='/expenses'><span>Expenses</span></RouterLink> 
            
            <div v-if="$store.getters.access(['tire', 'brand', 'size', 'pattern', 'other'])" class="btn-group dropend mb-2">
              <a class="btn btn-roadfly bi-diagram-3-fill dropdown-toggle" data-bs-toggle='dropdown'><span>Products</span></a>
              <ul class='dropdown-menu'>
                <li v-if="$store.getters.access(['brand', 'size', 'pattern'])"><RouterLink class="dropdown-item" to='/specs'>Tires Specs</RouterLink></li>
                <li v-if="$store.getters.access('tire')" ><RouterLink class="dropdown-item" to='/tires'>Tires</RouterLink></li>
                <li v-if="$store.getters.access(['cost_edit', 'price_edit'])" ><RouterLink class="dropdown-item" to='/prices'>Tires Prices</RouterLink></li>
                <li v-if="$store.getters.access('product_other')" ><RouterLink class="dropdown-item" to='/others'>Other Products</RouterLink></li>
              </ul>
            </div>
            
            <!-- <div class="btn-group dropend mb-2">
              <a class="btn btn-roadfly bi-bar-chart dropdown-toggle" data-bs-toggle='dropdown'>Statistics</a>
              <ul class='dropdown-menu'>
                <li><RouterLink class="dropdown-item" to='/stats/soldValue'>Sold Value</RouterLink></li>
                <li><RouterLink class="dropdown-item" to='/stats/branchesSales'>Branches Sales</RouterLink></li>
              </ul>
            </div> -->

            <div v-if="$store.getters.access('stock')" class="btn-group dropend mb-2">
              <a class="btn btn-roadfly bi-inboxes-fill dropdown-toggle" data-bs-toggle='dropdown'><span>Inventory</span></a>
              <ul class='dropdown-menu'>
                <li v-if="$store.getters.access(['stock_view', 'stock_supply', 'stock_return'])"><RouterLink class="dropdown-item" to='/stock/'>Stock</RouterLink></li>
                <li v-if="$store.getters.access('stock_transfer')"><RouterLink class="dropdown-item" to='/stock/transfer'>Transfer</RouterLink></li>
                <li v-if="$store.getters.access('stock_transfer')"><RouterLink class="dropdown-item" to='/stock/transferOrders'>Transfer Orders</RouterLink></li>
                <li v-if="$store.getters.access('stock_supply_log')"><RouterLink class="dropdown-item" to='/stock/supplyLog'>Supply Log</RouterLink></li>
                <!-- <li><RouterLink class="dropdown-item" to='/stock/TransferLog'>Transfer Log</RouterLink></li>
                <li><RouterLink class="dropdown-item" to='/stock/ReturnLog'>Return Log</RouterLink></li> -->
              </ul>
            </div>
            
            <RouterLink v-if="$store.getters.access('customer')" class="btn btn-roadfly bi-people-fill mb-2" to='/customers'><span>Customers</span></RouterLink> 
            
            <div v-if="$store.getters.access('sales')" class="btn-group dropend mb-2">
              <a class="btn btn-roadfly bi-piggy-bank-fill dropdown-toggle" data-bs-toggle='dropdown'><span>Sales</span></a>
              <ul class='dropdown-menu'>
                <li v-if="$store.getters.access('sales_cashier')"><RouterLink class="dropdown-item" to='/sales/cashier'>Cashier</RouterLink></li>
                <li v-if="$store.getters.access('sales_invoices')"><RouterLink class="dropdown-item" to='/sales/invoices'>Invoices</RouterLink></li>
                <!-- <li v-if="$store.getters.access('sales_return')"><RouterLink class="dropdown-item" to='/sales/return'>Return</RouterLink></li> -->
                <li v-if="$store.getters.access('sales_return_invoices')"><RouterLink class="dropdown-item" to='/sales/returns'>Returns Receipts</RouterLink></li>
              </ul>
            </div>
            
            <a id="logout" class="btn btn-roadfly bi-door-open-fill mb-2" @click="logout()"><span>Logout</span></a> 

        </div>
    </div>
</template>
<!-- ******************************************************** -->
<script>
  export default {
    // eslint-disable-next-line
    name: 'Menu',
    data(){
      return {
        session_time: '',
      }
    },
    async created() {
      this.session_time = parseInt((this.$store.state.token_end - Date.now()) / 1000);
    },
    computed:{
      session_life(){
        let seconds = this.session_time;
        let hours = Math.floor(seconds / 3600);
        seconds %= 3600;
        let minutes = Math.floor(seconds / 60);
        seconds = seconds % 60;

        var str = '';
        if(hours) str += `${hours} h `
        if(minutes) str += `${minutes} m `
        if(seconds) str += `${seconds} s `
        return str;
      }
    },
    watch: {
      session_time:{
        handler() {
          setTimeout(() =>{
            if(!this.$store.state.token_end) return;
            this.session_time = parseInt((this.$store.state.token_end - Date.now()) / 1000);
            if(this.session_time < 0){
              return this.logout();
            }
          }, 1000);
        },
        immediate: true
      }
    },
    methods:{
      async logout(){
        await this.$service.logout();
        // this.$cookies.remove('token');
        this.$store.dispatch('clearAll');
        this.$router.replace('/login');
      },
      getNameClassStyle(){
        if(this.$store.state.type == 'user') return 'fw-bold text-dark';
        if(this.$store.state.type == 'super') return 'fw-bold bi-stars text-danger';
        if(this.$store.state.type == 'admin') return 'fw-bold bi-star-fill text-success';
        if(this.$store.state.type == 'advanced user') return 'fw-bold bi-star text-success';
      }
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
#menu_container{
  position: absolute;
  padding-top: 10px;
  float: left;
  width: 20%;
  height: 100% !important;
  border-right: 1px solid grey;
  text-align: center;
}
#menu_container #logo{
    display: block;
    width: 100%;
    left: 0;
    right: 0;
    margin: auto;
    height: auto;
}
#menu{
    padding: 0;
    margin: 0;
    width: 100%;
}
#menu p:first-child{
    display: inline-block;
    width: 100%;
    text-align: center;
}
#menu *{
    border-radius: 0 !important;
}
#menu .dropdown-toggle::after{
    position: absolute !important;
    right: 15px !important;
    margin-top: 8px;
}
#menu .btn-group, .btn{
  width: 100% !important;
}
#menu #logout{
  bottom: 5% !important;
  left: 0 !important;
  position: absolute !important;
}
/* -------------------------------------------------- */
*:not(.dropstart) > .btn::before{
    position: absolute !important;
    width: auto !important;
    height: 80% !important;
    left: 5% !important;
    fill: white !important;
    top: 0;
    bottom: 0;
    margin: auto;
    font-size: 170%;
}
/* -------------------------------------------------- */
#alarm{
  position: absolute;
  top: 0;
  right: 10px;
  font-size: 24pt;
  color: var(--c-primary);
  cursor: pointer;
}
#alarm:hover{
  color: #2c4ba1;
}
/* -------------------------------------------------- */
.session_time{
  /* position: absolute;
  left: 0;
  right: 0;
  bottom: 0; */
  font-size: 10pt !important;
  padding: 0;
  margin: 0;
}
/* -------------------------------------------------- */

@media (max-width: 480px) {
  #menu a span{
    color: transparent !important;
  }
}
</style>
  